import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewComponent } from './new.component';
import { InternalComponent } from './internal/internal.component';
import { ExternalComponent } from './external/external.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTabsModule } from '@angular/material/tabs';
import { NdgDataFisComponent } from './tabs/ndg-data-fis/ndg-data-fis.component';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';
import { NdgDataGiuComponent } from './tabs/ndg-data-giu/ndg-data-giu.component';
import { NeedsFisComponent } from './tabs/needs-fis/needs-fis.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProtectionComponent } from './tabs/protection/protection.component';
import { NeedsGiuComponent } from './tabs/needs-giu/needs-giu.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SavingsComponent } from './tabs/savings/savings.component';
import { PrevidenceComponent } from './tabs/previdence/previdence.component';
import { FinalComponent } from './tabs/final/final.component';
import { SavingsShortListComponent } from './tabs/savings-short-list/savings-short-list.component';
import { ExitDialogComponent } from './external/exit-dialog/exit-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    NewComponent,
    InternalComponent,
    ExternalComponent,
    NdgDataFisComponent,
    NdgDataGiuComponent,
    NeedsFisComponent,
    ProtectionComponent,
    NeedsGiuComponent,
    SavingsComponent,
    PrevidenceComponent,
    FinalComponent,
    SavingsShortListComponent,
    ExitDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,

    MatTabsModule,
    MatInputModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatDialogModule,
    MatTooltipModule,

    NgxMaskModule.forRoot(),
    NgbDatepickerModule
  ],
  exports: [
    NdgDataFisComponent,
    NdgDataGiuComponent,
    NeedsFisComponent,
    NeedsGiuComponent,
    ProtectionComponent,
    SavingsComponent,
    SavingsShortListComponent,
    PrevidenceComponent
  ]
})
export class NewModule { }
